module.exports = __webpack_public_path__ + "static/media/UniNeueHeavy.970bebd9.woff";